import * as orderList from '../services/orderList';

export default {
  namespace: 'orderListEC',

  state: {
    // userInfo: null,
    // getMemberList: null,
    // addMember: null,
  },

  effects: {
    *getOrderList({ payload: { values } }, { call, put }) {
      const response = yield call(orderList.getOrderList, values);
      yield put({
        type: 'save',
        payload: {
          orderList: response?.data,
        },
      });
    },
    *getOrderSummary({ payload: { values } }, { call, put }) {
      const response = yield call(orderList.getOrderSummary, values);
      yield put({
        type: 'save',
        payload: {
          orderSummary: response?.data,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
